import env from "@/env.mjs";
import { algoliasearch } from "algoliasearch";

export const algoliaClient = algoliasearch(
	env.NEXT_PUBLIC_ALGOLIA_APP_ID,
	env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
);

export const ALGOLIA_PRODUCTS_INDEX = "products-index";

export const HITS_PER_PAGE = 8;
